import { forwardRef, ReactNode, useState } from "react";
import {ChevronDown, LucideProps,Menu} from "lucide-react";
import MenuIcon, { AppMenuOptions } from "modules/main/types/menus";
import { cn } from "@/lib/utils"

import {
    NavigationMenu,
    NavigationMenuContent,
    // NavigationMenuIndicator,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
    NavigationMenuItem
} from "@/components/ui/navigation-menu"



import { Link, LinkProps } from "react-router-dom";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";
import { Sheet, SheetClose, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { AvatarOptions } from "modules/users/avatar-options";
import { Separator } from "@/components/ui/separator";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useAuth } from "modules/authentication/hooks/use-auth";




const AppMenu:React.FC<{menu:AppMenuOptions[],mobile:boolean}> = ({menu, mobile}) => {
    return (
        (!mobile)?(DesktopNavMenu({menu})):MobileDrawerMenu({menu})
    )    
}

const MobileDrawerMenu:React.FC<{menu:AppMenuOptions[]}> = ({menu}) => {
    const {isLogged} = useAuth();   
    return (
    <Sheet>
        <SheetTrigger>
            <Menu className="w-6 h-6 text-primary"/>      
        </SheetTrigger>
        <SheetContent side={'left'} className="[&>button:first-child]:hidden">
            <SheetHeader>
                <SheetTitle></SheetTitle>
                <SheetDescription></SheetDescription>
            </SheetHeader>
            <ScrollArea className="h-[100dvh]">       
                {isLogged?(
                <>
                <AvatarOptions isMobile={true} />           
                </>                
                ):(
                    <span className="font-semibold text-sm">Categorias</span>
                )} 
                <Separator className="w-[90%] mt-4 mb-1" />         
                <nav className="grid gap-4 px-2 group-[[data-collapsed=true]]:justify-center group-[[data-collapsed=true]]:px-2">
                <Accordion type="single" collapsible >
                {
                menu.map((item,index) => {
                return (
                    <AccordionItem value={index.toString()} key={index} className="border-hidden">
                        <AccordionTrigger className="m-0 py-2">
                            <div className="flex items-center gap-2">
                                <MenuIcon iconName={item.icon} size={24} className={item.color}/>      
                                <span className="text-xs">{item.name}</span>              
                            </div>                        
                        </AccordionTrigger>
                        <AccordionContent>
                            <nav className="flex flex-col gap-2 px-4 text-muted-foreground">
                            {
                            item.sub_menu?.map( (subMenu, subIndex) => {
                                return (
                                    <SheetClose asChild key={subIndex}> 
                                        <Link to={`/catalog/${subMenu.slug}`} 
                                        className={cn(  
                                            "text-xs",
                                            "dark:bg-muted dark:text-muted-foreground dark:hover:bg-muted dark:hover:text-white",     
                                            "hover:bg-accent hover:text-foreground"                   
                                        )}                                        
                                        >
                                        {subMenu.name}
                                        </Link>
                                    </SheetClose>
                                );
                            })}
                            </nav>
                        </AccordionContent>
                    </AccordionItem>
                )})
                
                }
                    </Accordion>
                </nav>            </ScrollArea>
        </SheetContent>
    </Sheet>)
}

const DesktopNavMenu:React.FC<{menu:AppMenuOptions[]}> = ({menu}) => {
    const [isVisible, setIsVisible] = useState(true);

    return (
        <div className="relative flex justify-center">
            <NavigationMenu className={cn("transition-all duration-300 ease-in-out",{                                        
                                        "max-h-0 opacity-0 overflow-hidden": !isVisible,
                                        "max-h-20 opacity-100": isVisible
                                    })}>
                <div className="flex w-[95vw] justify-center">
                {
                menu.map((item,index) => {
                    return (           
                <NavigationMenuList key={index}>
                    <NavigationMenuItem>
                        <NavigationMenuTrigger>
                            <div className="flex flex-col items-center gap-2 2xl:max-w-[6vw]: xl:max-w-[4vw] lg:max-w-[4vw] md:max-w-[4vw]">
                                <MenuIcon iconName={item.icon} size={24} className={item.color}/>   
                                <span className={`hidden xl:block ml-2 text-xs 2xl:text-sm  ${item.color}`}>{item.name}</span>
                            </div>
                        </NavigationMenuTrigger>
                        <NavigationMenuContent>
                            <div className="flex flex-row w-[90vw] lg:w-[90vw] md:w-[90vw]">
                                {(item.layout === 'left')&&(
                                    <div className="w-[80%] p-4 z-10">
                                        <AspectRatio ratio={ 16 / 7}>
                                            <img className="Image" src={item.url} alt=""/>
                                        </AspectRatio>
                                    </div>
                                    )}                            
                                <ul className="grid w-full content-start gap-3 p-4 align-top  lg:grid-cols-2 z-10">
                                    {
                                        item.sub_menu?.map( (subMenu, subIndex) => {
                                            return (
                                                <SubMenu key={`${index}-${subIndex}`} title={subMenu.name} to={`/catalog/${subMenu.slug}`}/>                                      
                                            );
                                        }                                
                                        )
                                    }                            
                                </ul>
                                {(item.layout === 'right')&&(
                                <div className="w-[60%] p-4 z-10">
                                    <AspectRatio ratio={ 16 / 7}>
                                        <img className="Image" src={item.url} alt=""/>
                                    </AspectRatio>
                                </div>
                                )}
                            </div>
                        </NavigationMenuContent>                    
                    </NavigationMenuItem>
                </NavigationMenuList>          
                    );
                    }        
                )
                }
            </div>
            </NavigationMenu>    
            <div className="absolute w-[90%] bottom-[-1.4rem]">
                <div className="bg-white w-10 m-auto  rounded-b-md border shadow cursor-pointer"
                        onClick={
                            () => {
                                setIsVisible(!isVisible);
                            }
                        }
                >
                    <ChevronDown className={cn("w-3 h-3 m-auto transition-transform duration-300",
                        { "rotate-180": !isVisible }  , 
                    )}/>
                </div>             
            </div>              
        </div>  
    )
}

interface SubMenuAdditionalProps{
    className?: string;
    title: string;
    icon?: React.FC<LucideProps>;
    children?: ReactNode;
}
type SubMenuProps = LinkProps & SubMenuAdditionalProps;

const SubMenu = forwardRef<
                    React.ElementRef<typeof Link>,
                    SubMenuProps>(({className, icon:Icon,title, children,to, ...props }, ref) => {
    
    return(
        <li>
            <NavigationMenuLink asChild>
                <Link to={to || ''} ref={ref}
                    className={cn(
                        "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
                        className
                    )}
                >        
                    {/* <div className=>                     */}
                        <div className="text-xs 2xl:text-sm font-medium leading-none"> {Icon && <Icon className="icon" size={16} />}  {title}</div>
                        <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                            {children}
                        </p>
                    {/* </div>     */}
                </Link>
            </NavigationMenuLink>
        </li>
    )
});
export default AppMenu;